const ModeActions = require("../actions/ModeActions.js");

const ModeReducers = {
    [ModeActions.Switch](prev, action) {
        return Object.assign({}, prev, {
            Mode: action.Mode
        });
    },
};

module.exports = ModeReducers;


// WEBPACK FOOTER //
// ./src/reducers/ModeReducers.js